import React, { useState } from 'react';
import CheckBoxContainer from './CheckBoxContainer';
import SelectContainer from './SelectContainer';
import { ReactComponent as ArrowIcon } from '../../assets/icons/chevron-down.svg';
import classes from './index.module.scss';

const ReportsTable = ({ register, list, inputList }) => {
  const [show, setShow] = useState(false);

  const toggleFilterOptions = () => {
    setShow(!show);
  }

  return (
    <>
      <fieldset className="mb-5">
        <label htmlFor="select" className="mb-4">Please select one or more fields for export</label>
        <CheckBoxContainer 
          list={list}
          register={register}
        />
      </fieldset>
      <fieldset>
        <label htmlFor="filter" className="mb-4">
          Filter Options
          <ArrowIcon 
            className={classes.Arrow_Icon}
            onClick={toggleFilterOptions}
          />
        </label>
        {show && <SelectContainer list={inputList} />}
      </fieldset>
    </>
  )
}

export default ReportsTable;